module.exports = __webpack_public_path__ + "img/vip-liwu.6bc6e37a.png";